import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiMail } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/policy-center.scss";

function PolicyPage({ title, kicker, intro, sections, related = [], tone = "ink" }) {
  return (
    <main className="policy-centre" data-tone={tone}>
      <header className="policy-centre__hero page-shell">
        <div className="policy-centre__index" aria-hidden="true">
          {String(sections.length).padStart(2, "0")}
        </div>
        <div>
          <p className="eyebrow">{kicker}</p>
          <h1>{title}</h1>
        </div>
        <div className="policy-centre__intro">
          <p>{intro}</p>
          <small>Reviewed 3 November 2026 · English</small>
        </div>
      </header>

      <div className="policy-centre__layout page-shell">
        <aside className="policy-centre__rail">
          <p className="eyebrow">On this page</p>
          <nav aria-label={`${title} sections`}>
            {sections.map((section, index) => (
              <a key={section.title} href={`#section-${index + 1}`}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                {section.title}
              </a>
            ))}
          </nav>
        </aside>

        <article className="policy-centre__article">
          {sections.map((section, index) => (
            <section key={section.title} id={`section-${index + 1}`}>
              <div className="policy-centre__number">{String(index + 1).padStart(2, "0")}</div>
              <div>
                <h2>{section.title}</h2>
                {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
                {section.bullets?.length > 0 && (
                  <ul>{section.bullets.map((item) => <li key={item}>{item}</li>)}</ul>
                )}
                {section.note && <div className="policy-centre__note">{section.note}</div>}
              </div>
            </section>
          ))}
        </article>
      </div>

      <section className="policy-centre__contact page-shell" aria-label="Policy contact">
        <div><FiMail aria-hidden="true" /></div>
        <div>
          <p className="eyebrow">Questions or requests</p>
          <h2>Write to the team that handles the issue.</h2>
          <p>
            Include your order number when the request concerns a purchase. Never email card details or security codes.
            Mandatory consumer and privacy rights that apply to you are not limited by this policy.
          </p>
        </div>
        <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email} <FiArrowRight /></a>
      </section>

      {related.length > 0 && (
        <nav className="policy-centre__related page-shell" aria-label="Related policies">
          <p className="eyebrow">Continue reading</p>
          <div>
            {related.map((item) => <Link key={item.to} to={item.to}>{item.label} <FiArrowRight /></Link>)}
          </div>
        </nav>
      )}
    </main>
  );
}

export default PolicyPage;
